/**
 * Az ATIRAT-MERES felolvasando szovege - EGY forrasbol.
 *
 * Ebbol keszul a felolvaso nezet (a hivasban, nagy betuvel) ES a kiertekelo
 * referenciaszovege. Ha a ketto kulon helyen elne, egy javitas az egyikben
 * csendben elrontana a merest: a felolvasott szoveg mast mondana, mint amihez
 * merunk.
 *
 * A szamok szamjeggyel allnak: a felolvaso termeszetesen mondja ki oket, a
 * modellek szamjeggyel irjak, es a meres a tagolast nem tekinti hibanak.
 */

export type ScriptSpeaker = 'A' | 'B' | 'telefon' | 'mindketten';

export interface ScriptPart {
  title: string;
  speaker: ScriptSpeaker;
  /** Utasitas a felolvasonak - NEM resze a referenciának. */
  instruction?: string;
  /** Csendszakasz: ennyi masodperc teljes csend (visszaszamlaloval). */
  silenceSeconds?: number;
  /** A felolvasando mondatok. Egymasba beszelesnel soronkent mas beszelo. */
  lines: { speaker?: ScriptSpeaker; text: string }[];
}

export const TEST_SCRIPT: ScriptPart[] = [
  {
    title: 'Bemutatkozás',
    speaker: 'A',
    lines: [
      {
        text: 'Jó napot kívánok, Kovács Eszter vagyok az Alpha-Vet ügyfélszolgálatáról. Szeptember 23-án, szerdán délelőtt 10 óra 15 perckor beszélünk. A mai téma a Doki4Vet felhős telepítése és a számlázás.',
      },
    ],
  },
  {
    title: 'Szakszöveg',
    speaker: 'B',
    lines: [
      {
        text: 'A rendelőben három munkaállomás van, a recepción egy Windows 11-es gép. A Vectory számlázóból tegnap két számla nem ment át a NAV Online Számla rendszerbe. A hibaüzenet szerint az adószám formátuma hibás: 12345678-2-42.',
      },
      {
        text: 'A kutya neve Bodri, a gazdája Nagy-Szabó Réka, a beadott oltás Nobivac DHPPi és Rabies, a gyógyszer pedig Metacam, napi egyszer 0,1 milliliter.',
      },
    ],
  },
  {
    title: 'Számok és elérhetőségek',
    speaker: 'A',
    lines: [
      {
        text: 'A visszahívási szám: +36 20 213 6047. Az e-mail-cím: recepcio kukac allatorvos-gyor pont hu. A cím: 9026 Győr, Egyetem utca 12, második emelet.',
      },
      {
        text: 'A licenc lejárata 2027. március 31., az ára havi 14 900 forint plusz áfa.',
      },
    ],
  },
  {
    title: 'Ügyfél kérése',
    speaker: 'B',
    lines: [
      {
        text: 'Halló, jól hallanak? Most mobilról hívom a rendelőt, kicsit zajos az utca. Azt szeretném kérni, hogy holnap reggel 8 és 9 között valaki telepítse fel a felhős verziót, mert a régi szerver lassú, és pénteken leltárt csinálunk.',
      },
    ],
  },
  {
    title: 'Csend',
    speaker: 'mindketten',
    instruction: 'Senki nem szól. Ebből derül ki, hogy a felismerő kitalál-e szöveget a csendből.',
    silenceSeconds: 30,
    lines: [],
  },
  {
    title: 'Egymásba beszélés',
    speaker: 'mindketten',
    instruction: 'A kettőt EGYSZERRE mondjátok, kb. 10 másodpercig ismételve.',
    lines: [
      { speaker: 'A', text: 'Akkor a telepítést holnap reggelre teszem.' },
      { speaker: 'B', text: 'Igen, de előtte küldjék el a jelszót e-mailben.' },
    ],
  },
  {
    title: 'Zárás',
    speaker: 'A',
    lines: [
      {
        text: 'Rendben, összefoglalom: holnap reggel 8-kor felhős telepítés, a két számlát újraküldjük a NAV-nak, a jelszót e-mailben kapják meg. Köszönöm a hívást, további szép napot!',
      },
    ],
  },
];

/** A referencia: pontosan a felolvasando mondatok, utasitasok nelkul. */
export const TEST_REFERENCE = TEST_SCRIPT.flatMap((part) =>
  part.lines.map((line) => line.text),
).join('\n');

export const TEST_TERMS =
  'Doki4Vet, Vectory, NAV, Nobivac, DHPPi, Rabies, Metacam, Bodri, Nagy-Szabó Réka, Kovács Eszter, Győr';
